import React from 'react'
import { Input, Space } from 'antd'
import { PortalStickyCta } from '../../../models/PortalArtigoModel'
import { createDefaultCta } from '../helpers/artigo-defaults'
import { PortalEditorField } from './PortalEditorField'
import { RichTextListEditor } from './PortalRichTextFields'

interface CtaEditorProps {
  value?: PortalStickyCta
  onChange: (value: PortalStickyCta) => void
}

export function CtaEditor({
  value,
  onChange,
}: CtaEditorProps) {
  const cta = value || createDefaultCta()

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <PortalEditorField label="Título do CTA">
        <Input
          value={cta.title}
          placeholder="Título"
          onChange={(event) => onChange({ ...cta, title: event.target.value })}
        />
      </PortalEditorField>
      <PortalEditorField label="URL do botão">
        <Input
          value={cta.href}
          placeholder="URL"
          onChange={(event) => onChange({ ...cta, href: event.target.value })}
        />
      </PortalEditorField>
      <PortalEditorField label="Texto do botão">
        <Input
          value={cta.label}
          placeholder="Texto do botão"
          onChange={(event) => onChange({ ...cta, label: event.target.value })}
        />
      </PortalEditorField>
      <RichTextListEditor
        label="Parágrafos"
        value={cta.paragraphs || []}
        onChange={(paragraphs) => onChange({ ...cta, paragraphs })}
      />
    </Space>
  )
}
